import SiteLayout from '@/components/feature/SiteLayout';
import usePageMeta from '@/hooks/usePageMeta';
import { articles, faqs } from '@/mocks/articles';
import HomeHero from './components/HomeHero';
import TrendingBar from './components/TrendingBar';
import CategoryShowcase from './components/CategoryShowcase';
import LatestFeed from './components/LatestFeed';
import BrandBand from './components/BrandBand';
import HomeFaq from './components/HomeFaq';
import SubscribeSection from './components/SubscribeSection';

const jsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '看料99',
    url: 'https://lfthg.cn/',
    description: '看料99 是专注独家爆料与首发资源的资讯门户，每日更新第一手消息。',
    email: 'hello@kanliao99.com',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '看料99',
    url: 'https://lfthg.cn/',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://lfthg.cn/category?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: '看料99 最新爆料',
    itemListElement: articles.slice(0, 6).map((a, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      url: `https://lfthg.cn/article/${a.id}`,
      name: a.title,
    })),
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  },
];

export default function Home() {
  usePageMeta({
    title: '看料99 - 首发爆料与独家内幕，第一手消息抢先看',
    description:
      '看料99 专注独家爆料与首发资源，每日更新第一手消息，覆盖娱乐、社会、职场等热门话题，深度还原事件脉络与未公开细节，满足你对真相的抢先需求。',
    keywords: '看料99,看料99首发爆料,看料99独家料,看料99第一手消息,看料99抢先看,看料99独家内幕',
    path: '/',
    jsonLd,
  });

  return (
    <SiteLayout>
      <div className="animate-fade-up">
        <HomeHero />
        <TrendingBar />
        <CategoryShowcase />
        <LatestFeed />
        <BrandBand />
        <HomeFaq />
        <SubscribeSection />
      </div>
    </SiteLayout>
  );
}